import React, { useState } from 'react';
import Text from '../../../components/atoms/Text'; 
import { Warning } from '@phosphor-icons/react';
import ModalFailedRenewal from '../../../components/organisms/ModalFailedRenewal';
import { SubscriptionType } from '../../../@types/Subscription';

interface FailedRenewalBannerProps {
	onRetry: () => void;
	failedSubscription?: SubscriptionType;
}

const FailedRenewalBanner: React.FC<FailedRenewalBannerProps> = ({
	onRetry,
	failedSubscription,
}) => {
	const [showModalFailedRenewal, setShowModalFailedRenewal] = useState(false);

	const handleBannerClick = () => {
		if (failedSubscription?.id) {
			setShowModalFailedRenewal(true);
		} else {
			onRetry();
		}
	};

	const handleCloseModal = (isCompleted: boolean) => {
		setShowModalFailedRenewal(false);
		if (isCompleted) {
			// If payment was completed successfully, you might want to refresh data
			// or call a callback function here
		}
	};

	return (
		<>
			<div 
				className='bg-gradient-to-r from-orange-50 to-orange-100 border border-orange-200 rounded-xl p-4 mb-4 shadow-sm cursor-pointer hover:shadow-md transition-shadow duration-200'
				onClick={handleBannerClick}
			>
				<div className='flex items-center gap-3'>
					{/* Warning icon from Phosphor */}
					<div className='flex-shrink-0 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center'>
						<Warning 
							size={24} 
							color='white' 
							weight='fill'
						/>
					</div>
					
					{/* Content */}
					<div className='flex-1 min-w-0'>
						<Text
							size='caption'
							weight='medium'
							sx='text-orange-800 leading-relaxed'
						>
							¡Tu plan de contabilidad está en riesgo! El pago por la renovación de tu plan ha fallado.
						</Text>
						<Text
							size='caption'
							weight='medium'
							sx='text-orange-800 leading-relaxed underline'
						>
							Haz clic aquí para realizar el pago y continuar tu plan sin interrupciones.
						</Text>
					</div>
				</div>
			</div>

			{/* Modal for failed renewal */}
			{failedSubscription?.id && (
				<ModalFailedRenewal
					showModal={showModalFailedRenewal}
					setShowModal={setShowModalFailedRenewal}
					subscriptionId={failedSubscription.id}
					onClose={handleCloseModal}
				/>
			)}
		</>
	);
};

export default FailedRenewalBanner; 